export default {
  header: {
    self: {},
    items: [
      {
        title: 'Home', // dashboard renamed to home-page
        root: true,
        alignment: 'left',
        page: 'home-page',
        translate: 'MENU.DASHBOARD',
      },
      {
        title: 'Education',
        root: true,
        alignment: 'left',
        page: 'education',
        translate: 'MENU.EDUCATION',
      },
      {
        title: 'Notifications',
        root: true,
        alignment: 'left',
        page: 'notification',
        translate: 'MENU.NOTIFICATION',
      },
      {
        title: 'Reminder Messages',
        root: true,
        alignment: 'left',
        page: 'reminder',
        translate: 'MENU.REMINDER',
      },
      {
        title: 'Users',
        root: true,
        alignment: 'left',
        page: 'users',
        translate: 'MENU.USERS',
      },
      {
        title: 'Reports',
        root: true,
        alignment: 'left',
        toggle: 'hover',
        translate: 'MENU.REPORTS',
        submenu: [
          {
            title: 'Reports Home',
            bullet: 'dot',
            page: 'report/dashboard',
            translate: 'MENU.REPORTS',
          },
          {
            title: 'Dashboard',
            bullet: 'dot',
            page: 'report/dashboard',
            translate: 'MENU.REPORTS.BADGE',
          },
          {
            title: 'Learning Reports',
            root: true,
            bullet: 'dot',
            alignment: 'left',
            toggle: 'hover',
            translate: 'MENU.REPORTS',
            submenu: [
              {
                title: 'Learning Activities Report',
                bullet: 'dot',
                page: 'report/discovery-zone',
                // isUserPro: true,
                translate: 'MENU.REPORTS.DISCOVERY_ZONE',
              },
              {
                title: 'Featured Lesson Report',
                bullet: 'dot',
                page: 'report/campaign',
                translate: 'MENU.REPORTS.CAMPAIGN',
              },
              {
                title: 'Knowledge Measurement Report',
                bullet: 'dot',
                page: 'report/resident-knowledge-indicator',
                translate: 'MENU.REPORTS.RESIDENT_KNOWLEDGE_INDICATOR',
              },
              {
                title: 'Material Searches Report',
                bullet: 'dot',
                page: 'report/material',
                translate: 'MENU.REPORTS.MATERIAL',
              },
              {
                title: 'Page Views Report',
                bullet: 'dot',
                page: 'report/page-views',
                translate: 'MENU.REPORTS.PAGE_VIEWS',
              },
              {
                title: 'Annual National Survey',
                bullet: 'dot',
                page: 'report/annual-survey',
                translate: 'MENU.REPORTS.BADGE',
              },
            ],
          },
          {
            title: 'Activity Reports',
            root: true,
            alignment: 'left',
            bullet: 'dot',

            toggle: 'hover',
            translate: 'MENU.REPORTS',
            submenu: [
              // {
              //   title: 'Users Report',
              //   bullet: 'dot',
              //   page: 'report/user',
              //   translate: 'MENU.REPORTS.USER',
              // },
              {
                title: 'Interactions Report',
                bullet: 'dot',
                page: 'report/interaction',
                translate: 'MENU.REPORTS.INTERACTION',
              },
              {
                title: 'New Subscriber Report',
                bullet: 'dot',
                page: 'report/new-subscribers',
                translate: 'MENU.REPORTS.NEW_SUBSCRIBERS',
              },
              {
                title: 'Problems Reported',
                bullet: 'dot',
                page: 'report/problem',
                translate: 'MENU.REPORTS.PROBLEM',
              },
              {
                title: 'Bulk Pickup Requests',
                bullet: 'dot',
                page: 'report/bulk-pickup/detail',
                translate: 'MENU.REPORTS.BULK.PICKUP',
              },
              {
                title: 'Badge Report',
                bullet: 'dot',
                page: 'report/badge',
                translate: 'MENU.REPORTS.BADGE',
              },
            ],
          },
        ],
      },
      // {
      //   title: 'Campaigns',
      //   root: true,
      //   alignment: 'left',
      //   page: 'campaigns',
      //   translate: 'MENU.CAMPAIGN'
      // },
      {
        title: 'What Goes Where',
        root: true,
        alignment: 'left',
        toggle: 'hover',
        page: 'report/wgw-material/detail',
        translate: 'MENU.WHAT_GOES_WHERE',
        submenu: [
          {
            title: 'What Goes Where Dashboard',
            bullet: 'dot',
            page: 'report/wgw-material/detail',
            translate: 'MENU.WHAT.GOES.WHERE.DASHBOARD',
          },
          {
            title: 'Getting Started/User Guides',
            bullet: 'dot',
            page: 'what-goes-where/home',
            translate: 'MENU.GET_STARTED_USER_GUIDES',
          },
          {
            title: 'Waste Types',
            bullet: 'dot',
            page: 'waste-type',
            translate: 'MENU.WASTE_TYPE',
          },
          {
            title: 'Categories',
            bullet: 'dot',
            page: 'category',
            translate: 'MENU.CATEGORY',
          },
          {
            title: 'Collection Requirements',
            bullet: 'dot',
            page: 'collection-requirement',
            translate: 'MENU.COLLECTION_REQUIREMENT',
          },
          {
            title: 'Depots',
            bullet: 'dot',
            page: 'depot',
            translate: 'MENU.DEPOT',
          },
          {
            title: 'Events',
            bullet: 'dot',
            page: 'event',
            translate: 'MENU.EVENT',
          },
          {
            title: 'Waste And Recycling Rules',
            bullet: 'dot',
            page: 'waste-recycling-rules',
            translate: 'MENU.WASTE_AND_RECYCLING_RULES',
          }
        ],
      },
      {
        title: 'Schedule',
        root: true,
        alignment: 'left',
        page: 'schedules',
        translate: 'MENU.SCHEDULE',
      },
      {
        title: 'Marketing Resources',
        root: true,
        alignment: 'left',
        toggle: 'hover',
        translate: 'MENU.MARKETING_SUPPORT',
        submenu: [
          {
            title: 'Browse By Material',
            isNotWorkplaceAdmin: true,
            bullet: 'dot',
            page: 'https://recyclingcalendars-my.sharepoint.com/:f:/g/personal/jgalad_recyclecoach_com/EgVIl36-DaZDhvg5-t_-Z3cBHx88DQgSqV08dPUOyVDvmA?e=HarfeC',
            translate: 'MENU.MARKETING_SUPPORT.BROWSE_BY_MATERIAL',
          },
          {
            title: 'Browse by Feature',
            isNotWorkplaceAdmin: true,
            bullet: 'dot',
            page: 'https://recyclingcalendars-my.sharepoint.com/:f:/g/personal/jgalad_recyclecoach_com/EhP7BBFWp-RJrRPXtVq_V1EB4ZHbIGhdb9dLe_ntLylcQw?e=kCdSbP',
            translate: 'MENU.MARKETING_SUPPORT.BROWSE_BY_FEATURE',
          },
          {
            title: 'Browse by Campaign',
            isNotWorkplaceAdmin: true,
            isUserPro: true,
            bullet: 'dot',
            page: 'https://recyclingcalendars-my.sharepoint.com/:f:/g/personal/jgalad_recyclecoach_com/EgUXu2wTFsVNlZbe6pAVNKUB4p6_rKaGTVb7sYCR_f79Fw?e=OZdWZH',
            translate: 'MENU.MARKETING_SUPPORT.BROWSE_BY_CAMPAIGN',
          },
          {
            title: 'Monthly Social Planners',
            isNotWorkplaceAdmin: true,
            bullet: 'dot',
            page: 'https://recyclingcalendars-my.sharepoint.com/:f:/g/personal/jgalad_recyclecoach_com/Em_0uJOboxdEj8eRQ3KbvegBc3Z1MXjtzbCFXtgN9ok5Lg?e=wTKr5R',
            translate: 'MENU.MARKETING_SUPPORT.MONTHLY_SOCIAL_PLANNERS',
          },
          {
            title: 'Seasonal Assets',
            isNotWorkplaceAdmin: true,
            bullet: 'dot',
            page: 'https://recyclingcalendars-my.sharepoint.com/:f:/g/personal/jgalad_recyclecoach_com/EkLMERj9_AdGtb4O60qfBTIBGc9jx-LTQsnGtXty9DfxMA?e=LDIl6S',
            translate: 'MENU.MARKETING_SUPPORT.SEASONAL_ASSETS',
          },
          {
            title: 'Guides, Best Practices & FAQs',
            isNotWorkplaceAdmin: true,
            bullet: 'dot',
            page: 'https://recyclingcalendars-my.sharepoint.com/:f:/g/personal/jgalad_recyclecoach_com/Eubs-4LSQZlFsmpzY-yEo20BjsZQ5zXDub6wdpn_s86iiA?e=g1qQKs',
            translate: 'MENU.MARKETING_SUPPORT.GUIDES_BEST_PRACTICES_FAQ',
          },
          {
            title: 'Flyers, Posters and Handouts',
            isNotWorkplaceAdmin: true,
            bullet: 'dot',
            page: 'https://recyclingcalendars-my.sharepoint.com/:f:/g/personal/jgalad_recyclecoach_com/Equi5MhU0PVGndRK2YTfPAABkqLracbPFdeMUxWxRF4yEA?e=4zScMU',
            translate: 'MENU.MARKETING_SUPPORT.FLYERS_POSTERS_HANDOUTS',
          },
          {
            title: 'App Promotion and User Acquisition',
            isNotWorkplaceAdmin: true,
            bullet: 'dot',
            page: 'https://recyclingcalendars-my.sharepoint.com/:f:/g/personal/jgalad_recyclecoach_com/EgKyewaWofBJtsZb1hUMzrcBbPnpatB9iDrAQP1afPyS8A?e=AQ3zRp',
            translate: 'MENU.MARKETING_SUPPORT.APP_PROMOTION',
          },
          {
            title: 'Featured Partner: Foam Cycle',
            isNotWorkplaceAdmin: true,
            bullet: 'dot',
            page: 'https://recyclingcalendars-my.sharepoint.com/:f:/g/personal/jgalad_recyclecoach_com/ElHq4qoaS8ZKlwk6n7CJywAB5pJlf79X6SmrTI7lKNrDBw?e=dh8jON',
            translate: 'MENU.MARKETING_SUPPORT.FEATURES_PARTNERS',
          },
        ],
      },
      {
        title: 'Request Support',
        root: true,
        alignment: 'left',
        page: 'request-support',
        translate: 'MENU.REQUEST.SUPPORT',
      },
    ],
  },
};
